var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9056 2.17068C21.1349 1.71199 21.6692 1.50658 22.1399 1.67733L22.2472 1.72347L28.2472 4.72347C28.5483 4.87404 28.7509 5.16436 28.7922 5.49304L28.8 5.61789V26.3818C28.8 26.7185 28.6309 27.0295 28.3554 27.2134L28.2472 27.2763L22.2472 30.2763C22.1083 30.3457 21.9552 30.3818 21.8 30.3818C21.2871 30.3818 20.8645 29.9958 20.8067 29.4984L20.8 29.3818L20.7995 27.9997L9.79998 27.9999C9.28715 27.9999 8.86448 27.6138 8.80671 27.1165L8.79998 26.9999L8.79989 21.555C8.26838 21.639 7.7078 21.5085 7.25777 21.1587L7.11205 21.0339L2.35352 16.4809L5.19557 13.7615L8.40899 16.8359L8.79952 16.4197L8.79998 4.99986C8.79998 4.48702 9.18603 4.06435 9.68336 4.00659L9.79998 3.99986L20.7995 3.99968L20.8 2.61789C20.8 2.50146 20.8203 2.38623 20.8598 2.27731L20.9056 2.17068Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7998 5V27H9.7998V21.039L9.8888 20.95L17.1908 13.187L14.2068 10.618L9.7998 15.301V5H20.7998Z",
    fill: "#DBE3E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7998 2.61768L27.7998 5.61768V26.3817L21.7998 29.3817V2.61768Z",
    fill: "#75A8F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 17C24.3521 17 24.7998 16.5523 24.7998 16C24.7998 15.4477 24.3521 15 23.7998 15C23.2475 15 22.7998 15.4477 22.7998 16C22.7998 16.5523 23.2475 17 23.7998 17Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3328 12L15.7998 13.2633L9.21367 20.2653C8.86438 20.6367 8.29827 20.6818 7.89683 20.3889L7.79393 20.3027L3.7998 16.481L5.19543 15.1457L8.4468 18.2562L14.3328 12Z",
    fill: "#71C865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.e149a55deabd5b741d1dde8e52a426a3.svg";
export { ForwardRef as ReactComponent };